import { useDispatch } from "react-redux";
import styles from "./DeleteModal.module.scss";
import Button from "../../../../../../common/components/xepp/button/Button";
import { removeSection } from "../../../../../../stores/slices/service-type-slice";
import { SectionDefinition } from "../../../../../../model/service-request/section-definition";

type Props = {
  onModalClose: () => void;
  title: string;
  message: string;
  onDeleteClick: () => void;
}

const DeleteModal = (props: Props) => {

  const onDeleteClick = () => {
      props.onDeleteClick();
      props.onModalClose();
  }

  return (
    <div className={styles.modalOverlay} onClick={() => {}}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.headerWrapper}>
          <div className={styles.titleDiv}>
            <span className={styles.title}>{props.title}</span>
          </div>
          <button className={styles.closeBtn} onClick={() => props.onModalClose()}>
            ×
          </button>
        </div>
        <div className={styles.bodyContainer}>
          <span>
            {props.message} 
          </span>
        </div>
        <div className={styles.footerWrapper}>
          <Button
            text={'Cancel'}
            onClick={props.onModalClose}
            variant={'outline'}
          />
          <Button
            text={'Delete'}
            onClick={onDeleteClick}
            variant={'secondary'}
          />
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
